import DemoCarModel from '../../../../../view/pages/posm/models/DemoCar.model';

import { TestDriveModel } from '../../../../../view/pages/posm/models/TestDrive.model';
import { TestDriveService } from '../../../test-drives';

export default {
  namespaced: true,
  state: {
    testDrives: [],
    paginations: {
      total: 0,
      totalPages: 0,
      currentPage: 1,
    },
    currentTestDrive: null,
    demoVehicles: [],
    reasons: [],
    loading: false,
    error: null,
  },
  getters: {
    getTestDrives: (state) => state.testDrives,
    getTotalItems: (state) => state.totalItems,
    getCurrentTestDrive: (state) => state.currentTestDrive,
    getDemoVehicles: (state) => state.demoVehicles,
    getReasons: (state) => state.reasons,
    getPaginations: (state) => state.paginations,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },
  mutations: {
    SET_TEST_DRIVES(state, { data, paginations }) {
      state.testDrives = data;
      state.paginations = paginations;
    },
    SET_CURRENT_TEST_DRIVE(state, testDrive) {
      state.currentTestDrive = testDrive;
    },
    SET_DEMO_VEHICLES(state, vehicles) {
      state.demoVehicles = vehicles;
    },
    SET_REASONS(state, reasons) {
      state.reasons = reasons;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    async fetchTestDrives({ commit }, params) {
      commit('SET_LOADING', true);
      try {
        const { data } = await TestDriveService.getAll(params);
        commit('SET_TEST_DRIVES', {
          data: TestDriveModel.fromJsonArray(data.data.data),
          paginations: data.data.paginations,
        });
      } catch (error) {
        console.log(error);
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    /**
     *
     * @param {*} param0 vuex
     * @param {string} id
     * @returns {TestDriveModel}
     */
    async fetchTestDriveById({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const { data } = await TestDriveService.getById(id);
        const testDrive = TestDriveModel.fromJson(data.data);
        commit('SET_CURRENT_TEST_DRIVE', testDrive);
        return testDrive;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async createTestDrive({ commit }, data) {
      commit('SET_LOADING', true);
      try {
        const response = await TestDriveService.create(data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async updateTestDrive({ commit }, { id, data }) {
      commit('SET_LOADING', true);
      try {
        const response = await TestDriveService.update(id, data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteTestDrive({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        await TestDriveService.delete(id);
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async changeTestDriveStatus({ commit }, { id, status }) {
      commit('SET_LOADING', true);
      try {
        const response = await TestDriveService.changeStatus(id, status);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchDemoVehicles({ commit }, params) {
      commit('SET_LOADING', true);
      try {
        const response = await TestDriveService.getDemoVehicles(params);
        commit('SET_DEMO_VEHICLES', response.data.data);
        return response.data.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchReasons({ commit }) {
      try {
        const { data } = await TestDriveService.getReasons();
        commit('SET_REASONS', data?.data);
        return data?.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      }
    },

    /**
     * @param {Object} params
     * @returns {Promise<{demoTickets: DemoCarModel[], paginations: PaginationModel}>}
     */
    async lookupDemoTickets({ commit }, params) {
      try {
        const { data } = await TestDriveService.lookupDemoTickets(params);
        const demoTickets = DemoCarModel.fromJsonArray(data?.data.data);
        return { demoTickets, paginations: data?.data.paginations };
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      }
    },

    async exportExcel({ commit }, params) {
      commit('SET_LOADING', true);
      try {
        await TestDriveService.exportExcel(params);
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
